// extracted by mini-css-extract-plugin
module.exports = {"main-component":"downArrow_main-component__2YUjl"};